import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from '../pages/app'
import { getWindow } from '@ztechapps/common.utils'

//get the client routeContext
const window = getWindow()

ReactDOM.hydrateRoot(
  document.getElementById('app'),
  <BrowserRouter>
    <App routeContext={window.__ROUTE_CONTEXT__} />
  </BrowserRouter>
)
console.log('hydrated')
